"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpriteLookup = void 0;
/**
 * @public
 * Store for sprite positions.
 */
class SpriteLookup {
    static createOne(imageCount) {
        return new Float32Array(imageCount * 4);
    }
    static toTypedArray(lookup) {
        return lookup;
    }
    static setSpriteAtIndex(sprite, index, x, y, width, height) {
        index *= 4;
        sprite[index] = x;
        sprite[index + 1] = y;
        sprite[index + 2] = width;
        sprite[index + 3] = height;
    }
    static getXAtIndex(sprite, imageIndex) {
        return sprite[imageIndex * 4];
    }
    static getYAtIndex(sprite, imageIndex) {
        return sprite[imageIndex * 4 + 1];
    }
    static getWidthAtIndex(sprite, imageIndex) {
        return sprite[imageIndex * 4 + 2];
    }
    static getHeightAtIndex(sprite, imageIndex) {
        return sprite[imageIndex * 4 + 3];
    }
}
exports.SpriteLookup = SpriteLookup;
//# sourceMappingURL=sprite-lookup.js.map